
const squareStyle = {
    borderRadius: '0',
    border: '1px solid #ced4da',
    fontSize:'14px'
};

export const TextInput = ({ label, name,id="", value, onChange,errorData,handleBlur, read = false, required = false, placeholder = '', type = 'text' }) => (
    <div className={label=="Country"|| label=="State"? "":"mb-1"} >
        <label  style={{marginBottom:'0px',fontWeight:"bold"}} className="form-label">{label} <span style={{color:'red'}}>{required && '*'}</span></label>
        <input
             id={id}
            type={type}
            className="form-control"
            name={name}
            value={value}
            readOnly={read}
            onChange={onChange}
            required={required}
            placeholder={placeholder}
            style={squareStyle}
            onBlur={async (e)=>{await handleBlur(e)}}
        />
        <label style={{color:"red"}} htmlFor="">{errorData}</label>
    </div>
);

export const SelectInput = ({ label,id="", name, value,errorData, onChange, required = false, options = [] }) => (
    <div className="mb-1">
        <label style={{marginBottom:'0px',fontWeight:"bold"}} className="form-label">{label} <span style={{color:'red'}}> {required && '*'} </span></label>
        <select
             id={id}
            className="form-select"
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            style={squareStyle}
        >
            <option value="">Select {label}</option>
            {options.map(option => (
                <option style={option?.style} disabled={option?.disabled} key={option.value} value={option.value}>  {option?.space && <>&nbsp;</>} {option.label}</option>
            ))}
        </select>
<label style={{color:"red"}} htmlFor="">{errorData}</label>
    </div>
);

export const CheckboxInput = ({ label, name,errorData, checked, onChange }) => (
    <div className="form-check mb-1">
        <input
            className="form-check-input"
            type="checkbox"
            name={name}
            checked={checked}
            onChange={onChange}
            style={{ ...squareStyle, width: '1.2em', height: '1.2em' }}
        />
        <label className="form-check-label m-0">{label}</label> <br />
<label style={{color:"red"}} htmlFor="">{errorData }</label>
    </div>
);



export const DateInput = ({ label,id="", name,errorData, value, onChange, required = false }) => (
    <div className="mb-1">
        <label style={{marginBottom:'0px',fontWeight:"bold"}}  className="form-label">{label} <span style={{color:'red'}}> {required && '*'} </span></label>
        <input
            type="date"
             id={id}
            className="form-control"
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            style={squareStyle}
        
        />
<label style={{color:"red"}} htmlFor="">{errorData}</label>
    </div>


);

const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const AddressSection = ({ prefix, formData,errorData,handleBlur, handleChange, required = false }) => {
    const prefixCapitalized = capitalizeFirstLetter(prefix);

    return (
        <>
        
            
            <div className="d-flex justify-content-between align-items-center ">
                <label style={{marginBottom:'0px',fontWeight:'bold'}} className="form-label mb-0">
                    {prefixCapitalized} Address {required && <span style={{color:'red'}}>*</span>}
                </label>

                {prefix === 'business' && (
                    <div className="form-check m-0">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="sameAsRegistered"
                            name="sameAsRegistered"
                            checked={formData.sameAsRegistered}
                            onChange={handleChange}
                        />
                        <label
                            className="form-check-label mb-0 ms-2"
                            htmlFor="isUnregisteredDealer"
                            style={{ userSelect: 'none' }}
                        >
                            Same as Registered
                        </label>
  
                    </div>
                )}
            </div>

           
            <textarea
                type="text"
                className="form-control  no-border-radius"
                name={`${prefix}Address`}
                id={`${prefix}Address`}
                value={formData[`${prefix}Address`]}
                onChange={handleChange}
                required={required}
                placeholder={`Enter ${prefixCapitalized} Address`}
                style={{...squareStyle,minHeight:'90px'}}
            />
       <label style={{color:"red",marginTop:'0px'}} htmlFor="">{errorData[`${prefix}Address`]}</label>


            
            <div className="row">
                <div className="col-md-6">
                    <TextInput
                        label="Pincode"
                        name={`${prefix}Pincode`}
                        id={`${prefix}Pincode`}
                        value={formData[`${prefix}Pincode`] || ''}
                        onChange={handleChange}
                        required={required}
                        inputClassName="no-border-radius"
                        errorData={errorData[`${prefix}Pincode`]}
                        handleBlur={handleBlur}
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        label="City"
                        name={`${prefix}City`}
                        id={`${prefix}City`}
                        value={formData[`${prefix}City`] || ''}
                        onChange={handleChange}
                        // read={false}
                        required={required}
                        inputClassName="no-border-radius"
                        errorData={errorData[`${prefix}city`]}
                        handleBlur={handleBlur}
                    />
                </div>

            </div>

           
            <div className="row">
                <div className="col-md-6">
                    <TextInput
                        label="State"
                        name={`${prefix}State`}
                        id={`${prefix}State`}
                        value={formData[`${prefix}State`] || ''}
                        onChange={handleChange}
                        // read={true}
                        required={required}
                        inputClassName="no-border-radius"
                        handleBlur={handleBlur}
                       
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        label="Country"
                        name={`${prefix}Country`}
                        id={`${prefix}Country`}
                        value={formData[`${prefix}Country`] || ''}
                        onChange={handleChange}
                        // read={true}
                        required={required}
                       
                        inputClassName="no-border-radius"
                        handleBlur={handleBlur}
                    />
                </div>
            </div>
        </>
    );
};
